module.exports = {
  FETCH_USER_ROLE_REQUEST: 'FETCH_USER_ROLE_REQUEST',
  FETCH_USER_ROLE_SUCCESS: 'FETCH_USER_ROLE_SUCCESS',
  FETCH_USER_ROLE_FAILURE: 'FETCH_USER_ROLE_FAILURE',
};
